import jwt_decode from 'jwt-decode';

// Papel admin (convenção do legado): usr.tipo === 2. Lido do token salvo.
// Obs.: o tipo entra no token no LOGIN — promover alguém exige novo login.
export const ADMIN_TIPO = 2;

interface TokenPayload {
  usr?: { tipo?: number };
}

export function getIsAdmin(): boolean {
  try {
    const token = localStorage.getItem('@Portal:token');
    if (!token) return false;
    const decoded = jwt_decode<TokenPayload>(token);
    return decoded?.usr?.tipo === ADMIN_TIPO;
  } catch {
    return false;
  }
}
